import AdminRouteSelector, { AdminRoute } from "@app/components/admin-route-selector.tsx";
import PageTitle from "@app/components/page-title.tsx";
import usePowerBiReportsData from "@app/data-hooks/use-power-bi-reports-data.ts";
import { RouteHelper } from "@app/helpers/route-helper.ts";
import { Box } from "@mui/material";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { QueryStatusRouter } from "bi-lib";
import { useMemo } from "react";

export const Route = createFileRoute("/_authenticated/_manager/reporting")({
    beforeLoad: RouteHelper.ManagerAuthGuard,
    component: Component,
});

function Component() {
    const { reportsList } = usePowerBiReportsData();

    const routes = useMemo(() => {
        return (
            reportsList.data?.map<AdminRoute>((report) => ({
                to: `/reporting/${report.reportId}`,
                name: report.reportName!,
            })) ?? []
        );
    }, [reportsList.data]);

    return (
        <>
            <PageTitle>Reporting</PageTitle>
            <QueryStatusRouter queryHook={reportsList}>
                <Box
                    display={"flex"}
                    sx={{ flexDirection: { xs: "column", md: "row" }, alignItems: { xs: "center", md: "flex-start" } }}
                    flexDirection={"row"}
                    gap={3}
                >
                    <AdminRouteSelector routes={routes} />
                    <Box display={"flex"} gap={2} flexWrap={"wrap"} height={"fit-content"} flexGrow={1}>
                        <Outlet />
                    </Box>
                </Box>
            </QueryStatusRouter>
        </>
    );
}
